import { CheckIcon } from '@blueprinthq/joy'
import {
  Box,
  Button,
  Heading,
  List,
  ListIcon,
  ListItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack
} from '@chakra-ui/react'
import React from 'react'
import { useHistory } from 'react-router-dom'

interface OutOfSessionsModalProps {
  isOpen: boolean
  onClose: () => void
}

export const OutOfSessionsModal = ({
  isOpen,
  onClose
}: OutOfSessionsModalProps) => {
  const history = useHistory()

  const handleManagePlan = () => {
    onClose()
    history.push('/settings/plan/manage')
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalBody p="6">
          <VStack spacing="6" align="center" textAlign="center">
            <Box
              w="100%"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              {/* TODO: replace with actual illustration */}
              <img
                style={{ borderRadius: '8px' }}
                src="https://res.cloudinary.com/hellojoy/image/upload/v1752536088/desktop-computer_e46wgp.png"
                alt="Desktop Computer"
              />
            </Box>

            <Box>
              <Heading size="md" mb="2">
                You're out of sessions
              </Heading>
              <Text color="gray.600" fontSize="sm">
                You've used up your session credits. To keep using Blueprint,
                purchase more credits and choose your plan.
              </Text>
            </Box>

            <Box w="full" textAlign="left">
              <Text fontSize="sm" fontWeight="bold" mb="2">
                Here's what to do next:
              </Text>
              <List spacing="1">
                <ListItem fontSize="sm">
                  <ListIcon as={CheckIcon} color="green.500" />
                  Pick your plan – Standard, Plus, or Pro
                </ListItem>
                <ListItem fontSize="sm">
                  <ListIcon as={CheckIcon} color="green.500" />
                  Buy session credits – Minimum 30
                </ListItem>
                <ListItem fontSize="sm">
                  <ListIcon as={CheckIcon} color="green.500" />
                  Set up auto-replenish – Stay uninterrupted (default: ON)
                </ListItem>
              </List>
            </Box>

            <Button colorScheme="blue" w="full" onClick={handleManagePlan}>
              Purchase Sessions
            </Button>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

// Hook for using the out of sessions modal
export const useOutOfSessionsModal = () => {
  const [isOpen, setIsOpen] = React.useState(false)

  const openModal = () => setIsOpen(true)
  const closeModal = () => setIsOpen(false)

  return {
    isOpen,
    openModal,
    closeModal
  }
}
